// Name and code derived from https://iatistandard.org/en/iati-standard/203/codelists/country/
export const COUNTRY_CODELIST = [
  {
    name: 'Afghanistan',
    code: 'AF',
    iso3: 'AFG',
  },
  {
    name: 'Åland Islands',
    code: 'AX',
    iso3: 'ALA',
  },
  {
    name: 'Albania',
    code: 'AL',
    iso3: 'ALB',
  },
  {
    name: 'Algeria',
    code: 'DZ',
    iso3: 'DZA',
  },
  {
    name: 'American Samoa',
    code: 'AS',
    iso3: 'ASM',
  },
  {
    name: 'Andorra',
    code: 'AD',
    iso3: 'AND',
  },
  {
    name: 'Angola',
    code: 'AO',
    iso3: 'AGO',
  },
  {
    name: 'Anguilla',
    code: 'AI',
    iso3: 'AIA',
  },
  {
    name: 'Antarctica',
    code: 'AQ',
    iso3: 'ATA',
  },
  {
    name: 'Antigua and Barbuda',
    code: 'AG',
    iso3: 'ATG',
  },
  {
    name: 'Argentina',
    code: 'AR',
    iso3: 'ARG',
  },
  {
    name: 'Armenia',
    code: 'AM',
    iso3: 'ARM',
  },
  {
    name: 'Aruba',
    code: 'AW',
    iso3: 'ABW',
  },
  {
    name: 'Australia',
    code: 'AU',
    iso3: 'AUS',
  },
  {
    name: 'Austria',
    code: 'AT',
    iso3: 'AUT',
  },
  {
    name: 'Azerbaijan',
    code: 'AZ',
    iso3: 'AZE',
  },
  {
    name: 'Bahamas',
    code: 'BS',
    iso3: 'BHS',
  },
  {
    name: 'Bahrain',
    code: 'BH',
    iso3: 'BHR',
  },
  {
    name: 'Bangladesh',
    code: 'BD',
    iso3: 'BGD',
  },
  {
    name: 'Barbados',
    code: 'BB',
    iso3: 'BRB',
  },
  {
    name: 'Belarus',
    code: 'BY',
    iso3: 'BLR',
  },
  {
    name: 'Belgium',
    code: 'BE',
    iso3: 'BEL',
  },
  {
    name: 'Belize',
    code: 'BZ',
    iso3: 'BLZ',
  },
  {
    name: 'Benin',
    code: 'BJ',
    iso3: 'BEN',
  },
  {
    name: 'Bermuda',
    code: 'BM',
    iso3: 'BMU',
  },
  {
    name: 'Bhutan',
    code: 'BT',
    iso3: 'BTN',
  },
  {
    name: 'Bolivia (Plurinational State of)',
    code: 'BO',
    iso3: 'BOL',
  },
  {
    name: 'Bonaire, Sint Eustatius and Saba',
    code: 'BQ',
    iso3: 'BES',
  },
  {
    name: 'Bosnia and Herzegovina',
    code: 'BA',
    iso3: 'BIH',
  },
  {
    name: 'Botswana',
    code: 'BW',
    iso3: 'BWA',
  },
  {
    name: 'Bouvet Island',
    code: 'BV',
    iso3: 'BVT',
  },
  {
    name: 'Brazil',
    code: 'BR',
    iso3: 'BRA',
  },
  {
    name: 'British Indian Ocean Territory',
    code: 'IO',
    iso3: 'IOT',
  },
  {
    name: 'Brunei Darussalam',
    code: 'BN',
    iso3: 'BRN',
  },
  {
    name: 'Bulgaria',
    code: 'BG',
    iso3: 'BGR',
  },
  {
    name: 'Burkina Faso',
    code: 'BF',
    iso3: 'BFA',
  },
  {
    name: 'Burundi',
    code: 'BI',
    iso3: 'BDI',
  },
  {
    name: 'Cambodia',
    code: 'KH',
    iso3: 'KHM',
  },
  {
    name: 'Cameroon',
    code: 'CM',
    iso3: 'CMR',
  },
  {
    name: 'Canada',
    code: 'CA',
    iso3: 'CAN',
  },
  {
    name: 'Cabo Verde',
    code: 'CV',
    iso3: 'CPV',
  },
  {
    name: 'Cayman Islands',
    code: 'KY',
    iso3: 'CYM',
  },
  {
    name: 'Central African Republic',
    code: 'CF',
    iso3: 'CAF',
  },
  {
    name: 'Chad',
    code: 'TD',
    iso3: 'TCD',
  },
  {
    name: 'Chile',
    code: 'CL',
    iso3: 'CHL',
  },
  {
    name: 'China',
    code: 'CN',
    iso3: 'CHN',
  },
  {
    name: 'Christmas Island',
    code: 'CX',
    iso3: 'CXR',
  },
  {
    name: 'Cocos (Keeling) Islands',
    code: 'CC',
    iso3: 'CCK',
  },
  {
    name: 'Colombia',
    code: 'CO',
    iso3: 'COL',
  },
  {
    name: 'Comoros',
    code: 'KM',
    iso3: 'COM',
  },
  {
    name: 'Congo (the)',
    code: 'CG',
    iso3: 'COG',
  },
  {
    name: 'Congo (the Democratic Republic of the)',
    code: 'CD',
    iso3: 'COD',
  },
  {
    name: 'Cook Islands',
    code: 'CK',
    iso3: 'COK',
  },
  {
    name: 'Costa Rica',
    code: 'CR',
    iso3: 'CRI',
  },
  {
    name: "Côte d'Ivoire",
    code: 'CI',
    iso3: 'CIV',
  },
  {
    name: 'Croatia',
    code: 'HR',
    iso3: 'HRV',
  },
  {
    name: 'Cuba',
    code: 'CU',
    iso3: 'CUB',
  },
  {
    name: 'Cyprus',
    code: 'CY',
    iso3: 'CYP',
  },
  {
    name: 'Czechia',
    code: 'CZ',
    iso3: 'CZE',
  },
  {
    name: 'Denmark',
    code: 'DK',
    iso3: 'DNK',
  },
  {
    name: 'Djibouti',
    code: 'DJ',
    iso3: 'DJI',
  },
  {
    name: 'Dominica',
    code: 'DM',
    iso3: 'DMA',
  },
  {
    name: 'Dominican Republic',
    code: 'DO',
    iso3: 'DOM',
  },
  {
    name: 'Ecuador',
    code: 'EC',
    iso3: 'ECU',
  },
  {
    name: 'Egypt',
    code: 'EG',
    iso3: 'EGY',
  },
  {
    name: 'El Salvador',
    code: 'SV',
    iso3: 'SLV',
  },
  {
    name: 'Equatorial Guinea',
    code: 'GQ',
    iso3: 'GNQ',
  },
  {
    name: 'Eritrea',
    code: 'ER',
    iso3: 'ERI',
  },
  {
    name: 'Estonia',
    code: 'EE',
    iso3: 'EST',
  },
  {
    name: 'Ethiopia',
    code: 'ET',
    iso3: 'ETH',
  },
  {
    name: 'Falkland Islands [Malvinas]',
    code: 'FK',
    iso3: 'FLK',
  },
  {
    name: 'Faroe Islands',
    code: 'FO',
    iso3: 'FRO',
  },
  {
    name: 'Fiji',
    code: 'FJ',
    iso3: 'FJI',
  },
  {
    name: 'Finland',
    code: 'FI',
    iso3: 'FIN',
  },
  {
    name: 'France',
    code: 'FR',
    iso3: 'FRA',
  },
  {
    name: 'French Guiana',
    code: 'GF',
    iso3: 'GUF',
  },
  {
    name: 'French Polynesia',
    code: 'PF',
    iso3: 'PYF',
  },
  {
    name: 'French Southern Territories',
    code: 'TF',
    iso3: 'ATF',
  },
  {
    name: 'Gabon',
    code: 'GA',
    iso3: 'GAB',
  },
  {
    name: 'Gambia',
    code: 'GM',
    iso3: 'GMB',
  },
  {
    name: 'Georgia',
    code: 'GE',
    iso3: 'GEO',
  },
  {
    name: 'Germany',
    code: 'DE',
    iso3: 'DEU',
  },
  {
    name: 'Ghana',
    code: 'GH',
    iso3: 'GHA',
  },
  {
    name: 'Gibraltar',
    code: 'GI',
    iso3: 'GIB',
  },
  {
    name: 'Greece',
    code: 'GR',
    iso3: 'GRC',
  },
  {
    name: 'Greenland',
    code: 'GL',
    iso3: 'GRL',
  },
  {
    name: 'Grenada',
    code: 'GD',
    iso3: 'GRD',
  },
  {
    name: 'Guadeloupe',
    code: 'GP',
    iso3: 'GLP',
  },
  {
    name: 'Guam',
    code: 'GU',
    iso3: 'GUM',
  },
  {
    name: 'Guatemala',
    code: 'GT',
    iso3: 'GTM',
  },
  {
    name: 'Guernsey',
    code: 'GG',
    iso3: 'GGY',
  },
  {
    name: 'Guinea',
    code: 'GN',
    iso3: 'GIN',
  },
  {
    name: 'Guinea-Bissau',
    code: 'GW',
    iso3: 'GNB',
  },
  {
    name: 'Guyana',
    code: 'GY',
    iso3: 'GUY',
  },
  {
    name: 'Haiti',
    code: 'HT',
    iso3: 'HTI',
  },
  {
    name: 'Heard Island and McDonald Islands',
    code: 'HM',
    iso3: 'HMD',
  },
  {
    name: 'Holy See',
    code: 'VA',
    iso3: 'VAT',
  },
  {
    name: 'Honduras',
    code: 'HN',
    iso3: 'HND',
  },
  {
    name: 'Hong Kong',
    code: 'HK',
    iso3: 'HKG',
  },
  {
    name: 'Hungary',
    code: 'HU',
    iso3: 'HUN',
  },
  {
    name: 'Iceland',
    code: 'IS',
    iso3: 'ISL',
  },
  {
    name: 'India',
    code: 'IN',
    iso3: 'IND',
  },
  {
    name: 'Indonesia',
    code: 'ID',
    iso3: 'IDN',
  },
  {
    name: 'Iran (Islamic Republic of)',
    code: 'IR',
    iso3: 'IRN',
  },
  {
    name: 'Iraq',
    code: 'IQ',
    iso3: 'IRQ',
  },
  {
    name: 'Ireland',
    code: 'IE',
    iso3: 'IRL',
  },
  {
    name: 'Isle of Man',
    code: 'IM',
    iso3: 'IMN',
  },
  {
    name: 'Israel',
    code: 'IL',
    iso3: 'ISR',
  },
  {
    name: 'Italy',
    code: 'IT',
    iso3: 'ITA',
  },
  {
    name: 'Jamaica',
    code: 'JM',
    iso3: 'JAM',
  },
  {
    name: 'Japan',
    code: 'JP',
    iso3: 'JPN',
  },
  {
    name: 'Jersey',
    code: 'JE',
    iso3: 'JEY',
  },
  {
    name: 'Jordan',
    code: 'JO',
    iso3: 'JOR',
  },
  {
    name: 'Kazakhstan',
    code: 'KZ',
    iso3: 'KAZ',
  },
  {
    name: 'Kenya',
    code: 'KE',
    iso3: 'KEN',
  },
  {
    name: 'Kiribati',
    code: 'KI',
    iso3: 'KIR',
  },
  {
    name: "Korea (the Democratic People's Republic of)",
    code: 'KP',
    iso3: 'PRK',
  },
  {
    name: 'Korea (the Republic of)',
    code: 'KR',
    iso3: 'KOR',
  },
  {
    name: 'Kosovo',
    code: 'XK',
    iso3: 'XKX',
  },
  {
    name: 'Kuwait',
    code: 'KW',
    iso3: 'KWT',
  },
  {
    name: 'Kyrgyzstan',
    code: 'KG',
    iso3: 'KGZ',
  },
  {
    name: "Lao People's Democratic Republic",
    code: 'LA',
    iso3: 'LAO',
  },
  {
    name: 'Latvia',
    code: 'LV',
    iso3: 'LVA',
  },
  {
    name: 'Lebanon',
    code: 'LB',
    iso3: 'LBN',
  },
  {
    name: 'Lesotho',
    code: 'LS',
    iso3: 'LSO',
  },
  {
    name: 'Liberia',
    code: 'LR',
    iso3: 'LBR',
  },
  {
    name: 'Libya',
    code: 'LY',
    iso3: 'LBY',
  },
  {
    name: 'Liechtenstein',
    code: 'LI',
    iso3: 'LIE',
  },
  {
    name: 'Lithuania',
    code: 'LT',
    iso3: 'LTU',
  },
  {
    name: 'Luxembourg',
    code: 'LU',
    iso3: 'LUX',
  },
  {
    name: 'Macao',
    code: 'MO',
    iso3: 'MAC',
  },
  {
    name: 'North Macedonia',
    code: 'MK',
    iso3: 'MKD',
  },
  {
    name: 'Madagascar',
    code: 'MG',
    iso3: 'MDG',
  },
  {
    name: 'Malawi',
    code: 'MW',
    iso3: 'MWI',
  },
  {
    name: 'Malaysia',
    code: 'MY',
    iso3: 'MYS',
  },
  {
    name: 'Maldives',
    code: 'MV',
    iso3: 'MDV',
  },
  {
    name: 'Mali',
    code: 'ML',
    iso3: 'MLI',
  },
  {
    name: 'Malta',
    code: 'MT',
    iso3: 'MLT',
  },
  {
    name: 'Marshall Islands',
    code: 'MH',
    iso3: 'MHL',
  },
  {
    name: 'Martinique',
    code: 'MQ',
    iso3: 'MTQ',
  },
  {
    name: 'Mauritania',
    code: 'MR',
    iso3: 'MRT',
  },
  {
    name: 'Mauritius',
    code: 'MU',
    iso3: 'MUS',
  },
  {
    name: 'Mayotte',
    code: 'YT',
    iso3: 'MYT',
  },
  {
    name: 'Mexico',
    code: 'MX',
    iso3: 'MEX',
  },
  {
    name: 'Micronesia (Federated States of)',
    code: 'FM',
    iso3: 'FSM',
  },
  {
    name: 'Moldova (the Republic of)',
    code: 'MD',
    iso3: 'MDA',
  },
  {
    name: 'Monaco',
    code: 'MC',
    iso3: 'MCO',
  },
  {
    name: 'Mongolia',
    code: 'MN',
    iso3: 'MNG',
  },
  {
    name: 'Montenegro',
    code: 'ME',
    iso3: 'MNE',
  },
  {
    name: 'Montserrat',
    code: 'MS',
    iso3: 'MSR',
  },
  {
    name: 'Morocco',
    code: 'MA',
    iso3: 'MAR',
  },
  {
    name: 'Mozambique',
    code: 'MZ',
    iso3: 'MOZ',
  },
  {
    name: 'Myanmar',
    code: 'MM',
    iso3: 'MMR',
  },
  {
    name: 'Namibia',
    code: 'NA',
    iso3: 'NAM',
  },
  {
    name: 'Nauru',
    code: 'NR',
    iso3: 'NRU',
  },
  {
    name: 'Nepal',
    code: 'NP',
    iso3: 'NPL',
  },
  {
    name: 'Netherlands',
    code: 'NL',
    iso3: 'NLD',
  },
  {
    name: 'Netherlands Antilles',
    code: 'AN',
    iso3: 'ANT',
  },
  {
    name: 'New Caledonia',
    code: 'NC',
    iso3: 'NCL',
  },
  {
    name: 'New Zealand',
    code: 'NZ',
    iso3: 'NZL',
  },
  {
    name: 'Nicaragua',
    code: 'NI',
    iso3: 'NIC',
  },
  {
    name: 'Niger',
    code: 'NE',
    iso3: 'NER',
  },
  {
    name: 'Nigeria',
    code: 'NG',
    iso3: 'NGA',
  },
  {
    name: 'Niue',
    code: 'NU',
    iso3: 'NIU',
  },
  {
    name: 'Norfolk Island',
    code: 'NF',
    iso3: 'NFK',
  },
  {
    name: 'Northern Mariana Islands',
    code: 'MP',
    iso3: 'MNP',
  },
  {
    name: 'Norway',
    code: 'NO',
    iso3: 'NOR',
  },
  {
    name: 'Oman',
    code: 'OM',
    iso3: 'OMN',
  },
  {
    name: 'Pakistan',
    code: 'PK',
    iso3: 'PAK',
  },
  {
    name: 'Palau',
    code: 'PW',
    iso3: 'PLW',
  },
  {
    name: 'Palestine, State of',
    code: 'PS',
    iso3: 'PSE',
  },
  {
    name: 'Panama',
    code: 'PA',
    iso3: 'PAN',
  },
  {
    name: 'Papua New Guinea',
    code: 'PG',
    iso3: 'PNG',
  },
  {
    name: 'Paraguay',
    code: 'PY',
    iso3: 'PRY',
  },
  {
    name: 'Peru',
    code: 'PE',
    iso3: 'PER',
  },
  {
    name: 'Philippines',
    code: 'PH',
    iso3: 'PHL',
  },
  {
    name: 'Pitcairn',
    code: 'PN',
    iso3: 'PCN',
  },
  {
    name: 'Poland',
    code: 'PL',
    iso3: 'POL',
  },
  {
    name: 'Portugal',
    code: 'PT',
    iso3: 'PRT',
  },
  {
    name: 'Puerto Rico',
    code: 'PR',
    iso3: 'PRI',
  },
  {
    name: 'Qatar',
    code: 'QA',
    iso3: 'QAT',
  },
  {
    name: 'Réunion',
    code: 'RE',
    iso3: 'REU',
  },
  {
    name: 'Romania',
    code: 'RO',
    iso3: 'ROU',
  },
  {
    name: 'Russia',
    code: 'RU',
    iso3: 'RUS',
  },
  {
    name: 'Rwanda',
    code: 'RW',
    iso3: 'RWA',
  },
  {
    name: 'Saint Barthélemy',
    code: 'BL',
    iso3: '',
  },
  {
    name: 'Saint Helena, Ascension and Tristan da Cunha',
    code: 'SH',
    iso3: 'SHN',
  },
  {
    name: 'Saint Kitts and Nevis',
    code: 'KN',
    iso3: 'KNA',
  },
  {
    name: 'Saint Lucia',
    code: 'LC',
    iso3: 'LCA',
  },
  {
    name: 'Saint Pierre and Miquelon',
    code: 'PM',
    iso3: 'SPM',
  },
  {
    name: 'Saint Vincent and the Grenadines',
    code: 'VC',
    iso3: 'VCT',
  },
  {
    name: 'Samoa',
    code: 'WS',
    iso3: 'WSM',
  },
  {
    name: 'San Marino',
    code: 'SM',
    iso3: 'SMR',
  },
  {
    name: 'Sao Tome and Principe',
    code: 'ST',
    iso3: 'STP',
  },
  {
    name: 'Saudi Arabia',
    code: 'SA',
    iso3: 'SAU',
  },
  {
    name: 'Senegal',
    code: 'SN',
    iso3: 'SEN',
  },
  {
    name: 'Serbia',
    code: 'RS',
    iso3: 'SRB',
  },
  {
    name: 'Seychelles',
    code: 'SC',
    iso3: 'SYC',
  },
  {
    name: 'Sierra Leone',
    code: 'SL',
    iso3: 'SLE',
  },
  {
    name: 'Singapore',
    code: 'SG',
    iso3: 'SGP',
  },
  {
    name: 'Slovakia',
    code: 'SK',
    iso3: 'SVK',
  },
  {
    name: 'Slovenia',
    code: 'SI',
    iso3: 'SVN',
  },
  {
    name: 'Solomon Islands',
    code: 'SB',
    iso3: 'SLB',
  },
  {
    name: 'Somalia',
    code: 'SO',
    iso3: 'SOM',
  },
  {
    name: 'South Africa',
    code: 'ZA',
    iso3: 'ZAF',
  },
  {
    name: 'South Georgia and the South Sandwich Islands',
    code: 'GS',
    iso3: 'SGS',
  },
  {
    name: 'Spain',
    code: 'ES',
    iso3: 'ESP',
  },
  {
    name: 'Sri Lanka',
    code: 'LK',
    iso3: 'LKA',
  },
  {
    name: 'Sudan',
    code: 'SD',
    iso3: 'SDN',
  },
  {
    name: 'South Sudan',
    code: 'SS',
    iso3: 'SSD',
  },
  {
    name: 'Suriname',
    code: 'SR',
    iso3: 'SUR',
  },
  {
    name: 'Sint Maarten',
    code: 'SX',
    iso3: 'SXM',
  },
  {
    name: 'Svalbard and Jan Mayen',
    code: 'SJ',
    iso3: 'SJM',
  },
  {
    name: 'Eswatini',
    code: 'SZ',
    iso3: 'SWZ',
  },
  {
    name: 'Sweden',
    code: 'SE',
    iso3: 'SWE',
  },
  {
    name: 'Switzerland',
    code: 'CH',
    iso3: 'CHE',
  },
  {
    name: 'Syrian Arab Republic',
    code: 'SY',
    iso3: 'SYR',
  },
  {
    name: 'Taiwan (Province of China)',
    code: 'TW',
    iso3: 'TWN',
  },
  {
    name: 'Tajikistan',
    code: 'TJ',
    iso3: 'TJK',
  },
  {
    name: 'Tanzania, United Republic of',
    code: 'TZ',
    iso3: 'TZA',
  },
  {
    name: 'Thailand',
    code: 'TH',
    iso3: 'THA',
  },
  {
    name: 'Timor-Leste',
    code: 'TL',
    iso3: 'TLS',
  },
  {
    name: 'Togo',
    code: 'TG',
    iso3: 'TGO',
  },
  {
    name: 'Tokelau',
    code: 'TK',
    iso3: 'TKL',
  },
  {
    name: 'Tonga',
    code: 'TO',
    iso3: 'TON',
  },
  {
    name: 'Trinidad and Tobago',
    code: 'TT',
    iso3: 'TTO',
  },
  {
    name: 'Tunisia',
    code: 'TN',
    iso3: 'TUN',
  },
  {
    name: 'Turkey',
    code: 'TR',
    iso3: 'TUR',
  },
  {
    name: 'Turkmenistan',
    code: 'TM',
    iso3: 'TKM',
  },
  {
    name: 'Turks and Caicos Islands',
    code: 'TC',
    iso3: 'TCA',
  },
  {
    name: 'Tuvalu',
    code: 'TV',
    iso3: 'TUV',
  },
  {
    name: 'Uganda',
    code: 'UG',
    iso3: 'UGA',
  },
  {
    name: 'Ukraine',
    code: 'UA',
    iso3: 'UKR',
  },
  {
    name: 'United Arab Emirates',
    code: 'AE',
    iso3: 'ARE',
  },
  {
    name: 'United Kingdom of Great Britain and Northern Ireland',
    code: 'GB',
    iso3: 'GBR',
  },
  {
    name: 'United States of America',
    code: 'US',
    iso3: 'USA',
  },
  {
    name: 'United States Minor Outlying Islands',
    code: 'UM',
    iso3: 'UMI',
  },
  {
    name: 'Uruguay',
    code: 'UY',
    iso3: 'URY',
  },
  {
    name: 'Uzbekistan',
    code: 'UZ',
    iso3: 'UZB',
  },
  {
    name: 'Vanuatu',
    code: 'VU',
    iso3: 'VUT',
  },
  {
    name: 'Venezuela (Bolivarian Republic of)',
    code: 'VE',
    iso3: 'VEN',
  },
  {
    name: 'Viet Nam',
    code: 'VN',
    iso3: 'VNM',
  },
  {
    name: 'Virgin Islands (British)',
    code: 'VG',
    iso3: 'VGB',
  },
  {
    name: 'Virgin Islands (U.S.)',
    code: 'VI',
    iso3: 'VIR',
  },
  {
    name: 'Wallis and Futuna',
    code: 'WF',
    iso3: 'WLF',
  },
  {
    name: 'Western Sahara',
    code: 'EH',
    iso3: 'ESH',
  },
  {
    name: 'Yemen',
    code: 'YE',
    iso3: 'YEM',
  },
  {
    name: 'Zambia',
    code: 'ZM',
    iso3: 'ZMB',
  },
  {
    name: 'Zimbabwe',
    code: 'ZW',
    iso3: 'ZWE',
  },
];
